let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cE1ja")).then(() => parcelRequire('6CpHo'));